import {createContext, useContext} from 'react'

const DiffMapContext = createContext()

export const DiffMapProvider = DiffMapContext.Provider
export const useDiffMapContext = () => useContext(DiffMapContext)
